import { makeRequest } from '../../../lib/api';

const NOTIFICATIONS_PATH = '/v1/notifications';

class fcmController {
  sendToken = (data: object = {}) => {
    return makeRequest('put', `${ NOTIFICATIONS_PATH }/fcm`, data);
  };

  getUserHistory = (since: string | number) => (
    makeRequest('get', `${ NOTIFICATIONS_PATH }/users/history?since=${ since }`)
  );
}

export default new fcmController();
